export default function (pref = '_') {
    return pref + Math.random().toString(36).substr(2, 9);
}
